// @ts-nocheck
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box, Button } from '@material-ui/core';
import { GridOverlay, GridToolbar } from '@material-ui/data-grid';
import { DataTable, EmptyState } from '../../../../common/components';
import { DateUtils } from '../../../../common/utils';
import { fetchCampaignEmailsUrl } from '../../state/eventActions';
import { useOnPendingActionFinish } from '../../../../common/hooks';
import { FETCH_EMAILS_URL } from '../../state/eventActionTypes';
import { selectEmailsUrl } from '../../state/eventSelectors';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    '& .MuiDataGrid-root': {
      border: '0',
      '& .MuiDataGrid-row': {
        '& .MuiIcon-root': {
          maxWidth: '0',
        },
        '&:hover .MuiIcon-root': {
          maxWidth: 'none',
        },
      },
    },
    '& .loading .MuiDataGrid-row *': {
      cursor: 'progress',
    },
  },
  text: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: 'auto',
  },
}));

function EmailsTab({ data }) {
  const [loading, setLoading] = useState(false);
  const [t] = useTranslation();
  const classes = useStyles();
  const { userId } = useParams();
  const dispatch = useDispatch();
  const emailsUrl = useSelector(selectEmailsUrl);
  const today = new Date();
  const cutOff = new Date(today.setDate(today.getDate() - 59));

  const directToCampaign = async (event, messageId) => {
    setLoading(true);
    const btn = event.target;
    btn.innerHTML = t('common.loading');
    const email = data.find(x => x.messageId === messageId);
    await dispatch(fetchCampaignEmailsUrl(userId, email)).finally(() => {
      btn.innerHTML = 'Link';
      setLoading(false);
    });
  };

  const openInNewTab = url => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  };

  useOnPendingActionFinish([FETCH_EMAILS_URL], () => {
    if (emailsUrl) openInNewTab(emailsUrl);
  });

  const renderUrlLink = params => {
    return new Date(params.row.sentOn).getTime() > cutOff.getTime() ? (
      <Button variant="outlined" onClick={e => directToCampaign(e, params.value)}>
        Link
      </Button>
    ) : (
      <Button variant="outlined" disabled>
        Expired
      </Button>
    );
  };

  const getColumnDefs = () => [
    {
      field: 'sentOn',
      headerName: t('campaignEmails.campaignEmailsSentOn'),
      width: 200,
      type: 'dateTime',
      valueFormatter: params => DateUtils.getDateTime(params.value),
    },
    {
      field: 'code',
      headerName: t('campaignEmails.campaignEmailsCode'),
      width: 250,
    },
    {
      field: 'segment',
      headerName: t('campaignEmails.campaignEmailsSegment'),
      width: 250,
    },
    {
      field: 'name',
      headerName: t('campaignEmails.campaignEmailsName'),
      width: 250,
      flex: 0.75,
    },
    {
      field: 'messageId',
      headerName: t('campaignEmails.campaignEmailsUrl'),
      width: 250,
      renderCell: renderUrlLink,
    },
  ];

  const getRowData = () =>
    data.map((emails, index) => ({
      ...emails,
      id: index,
    }));

  const renderNoRowsOverlay = () => (
    <GridOverlay>
      <EmptyState variant="empty" message={t('campaignEmails.campaignEmailsEmpty')} />
    </GridOverlay>
  );

  return (
    <Box id="EmailsTab-container" className={classes.container}>
      <DataTable
        id="EmailTab-table"
        components={{
          Toolbar: GridToolbar,
          NoRowsOverlay: renderNoRowsOverlay,
        }}
        columns={getColumnDefs()}
        rows={getRowData()}
        pageSize={20}
        pagination
        className={loading ? 'loading' : ''}
      />
    </Box>
  );
}

EmailsTab.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default EmailsTab;
